import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Itemlist} from './itemlist';

@Injectable()
export class ItemlistService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('itemlists?' + params.toString()).map((response: Response) => response.json());
  }

  getAllItemlists() {
    return this.http.get('itemlists/all').map((response: Response) => response.json());
  }

  getAllInv() {
    return this.http.get('salesinv/all').map((response: Response) => response.json());
  }

  getItemlistname(_id: string){
    return this.http.get('itemlists/getname/'+_id).map((response: Response) => response.json());
  }


  getById(_id: string) {
    return this.http.get('itemlists/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('itemlists/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('itemlists/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(itemlist: Itemlist) {
    return this.http.post('itemlists', itemlist).map((response: Response) => response.json());
  }

  update(itemlist: Itemlist) {
    return this.http.put('itemlists/' + itemlist.id, itemlist).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('itemlists/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pos/itemlists/itemlist.service.ts